<template>
	<div>
		<div>
			<div style="display: flex;justify-content: space-between">
				<div>
					<el-input placeholder="请输入手机号进行搜索，可以直接回车搜索..." prefix-icon="el-icon-search" clearable size="medium"
						@clear="initEmps" style="width: 350px;margin-right: 10px" v-model="keyword"
						@keydown.enter.native="initEmps" :disabled="showAdvanceSearchView"></el-input>
					<!-- <el-select v-model="fromTenant" placeholder="客户来源" size="medium"
						style="margin-left: 5px;margin-right: 5px">
						<el-option v-for="item in tenantList" :key="item.ktiId" :label="item.ktiName"
							:value="item.ktiId">
						</el-option>
					</el-select> -->
					<el-button icon="el-icon-search" type="primary" @click="initEmps" :disabled="showAdvanceSearchView">
						搜索
					</el-button>
				</div>
				<div>
					<el-button type="success" @click="exportData" icon="el-icon-download">
						导出数据
					</el-button>
				</div>
			</div>
		</div>
		<div style="margin-top: 10px">
			<el-table :data="emps" stripe border v-loading="loading" element-loading-text="正在加载..."
				element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
				style="width: 100%">
				<!-- <el-table-column
                        type="selection"
                        width="55">
                </el-table-column> -->
				<el-table-column prop="cusAppId" align="center" label="手机号" min-width="33.33%">
				</el-table-column>

				<!-- <el-table-column prop="cusOpenId" label="openID" align="center" width="220">
				</el-table-column>
				<el-table-column prop="cusUnionId" label="unionID" align="center" width="220">
				</el-table-column> -->
				<el-table-column prop="cusAuthCode" min-width="33.33%" align="center" label="隐形内容授权码">
				</el-table-column>
				<el-table-column
						align="center"
						min-width="33.33%"
				        label="操作">
				    <template slot-scope="scope">
				        <el-button @click="getAuthCode(scope.row)" style="padding: 3px" size="mini">获取授权码</el-button>
				    </template>
				</el-table-column>
			</el-table>
			<div style="display: flex;justify-content: flex-end">
				<el-pagination background @current-change="currentChange" @size-change="sizeChange"
					layout="sizes, prev, pager, next, jumper, ->, total, slot" :total="total">
				</el-pagination>
			</div>
		</div>

	</div>
</template>

<script>
	import {
		v4 as uuidv4
	} from 'uuid'
	export default {
		name: "Tenants",
		data() {
			return {
				title: '',
				showAdvanceSearchView: false,
				allDeps: [],
				emps: [],
				loading: false,
				loading2: false,
				dialogVisible: false,
				total: 0,
				page: 1,
				keyword: '',
				fromTenant: '',
				size: 10,
				formulasEnableList: [],
				tenantList: []
			}
		},
		mounted() {
			this.initEmps();
			this.initData();
		},
		methods: {
			exportData() {
				var params = {};
				params.cusFromTenantId = this.fromTenant
				let url = '/customer/basic/export';
				this.downLoadRequest(url, params).then(res => {
					const content = res
					const blob = new Blob([content])
					const fileName = '导出.xls'
					if ('download' in document.createElement('a')) { // 非IE下载
						const elink = document.createElement('a')
						elink.download = fileName
						elink.style.display = 'none'
						elink.href = URL.createObjectURL(blob)
						document.body.appendChild(elink)
						elink.click()
						URL.revokeObjectURL(elink.href) // 释放URL 对象
						document.body.removeChild(elink)
					} else { // IE10+下载
						navigator.msSaveBlob(blob, fileName)
					}
				});
			},
			initData() {
				this.getTenantsAllList()
			},
			getTenantsAllList() {
				let url = '/tenant/basic/getTenantsAllList';
				this.getRequest(url).then(resp => {
					if (resp.status == 200) {
						this.tenantList = resp.obj;
					} else {

					}
				});
			},
			sizeChange(currentSize) {
				this.size = currentSize;
				this.initEmps();
			},
			currentChange(currentPage) {
				this.page = currentPage;
				this.initEmps('advanced');
			},
			getAuthCode(item){
				var that = this
				console.log(item)
				var cusAppId = item.cusAppId
				this.loading = true;
				let url = '/customer/basic/getAuthCode/' + cusAppId ;
				this.getRequest(url).then(resp => {
					this.loading = false;
					if (resp) {
						var code = resp.obj;
						
						that.$alert(code, '授权码', {
						  confirmButtonText: '确定',
						  callback: action => {
							console.log("sdas")
							that.initEmps();
						  }
						});
					}
				});
			},
			initEmps(type) {
				this.loading = true;
				let url = '/customer/basic/getCustomersList?page=' + this.page + '&size=' + this.size;
				url += "&cusTelNum=" + this.keyword;
				url += "&cusFromTenantId=" + this.fromTenant;
				this.getRequest(url).then(resp => {
					this.loading = false;
					if (resp) {
						this.emps = resp.data;
						this.total = resp.total;
					}
				});
			}
		}
	}
</script>

<style scoped lang="scss">
	/* 可以设置不同的进入和离开动画 */
	/* 设置持续时间和动画函数 */
	.slide-fade-enter-active {
		transition: all .8s ease;
	}

	.slide-fade-leave-active {
		transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
	}

	.slide-fade-enter,
	.slide-fade-leave-to

	/* .slide-fade-leave-active for below version 2.1.8 */
		{
		transform: translateX(10px);
		opacity: 0;
	}

	.el-form-item {
		display: flex;

		.input_box {
			width: 28.5rem;

			.el-input {
				width: 100% !important;
			}

			.el-select {
				width: 100% !important;
			}
		}
	}

	.advance_seit_box {
		line-height: 2.5rem;
		height: 2.5rem;
		font-size: 0.875rem;

		.box_tit {
			font-size: 0.875rem;
		}
	}

	.advance_btn_warp {
		line-height: 2.5rem;
		height: 2.5rem;
	}

	.options_warp {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;

		.option_item {
			margin-bottom: 0.625rem;
		}
	}

	::v-deep .dialog-box {
		.el-form-item__label {
			width: 5.125rem;
		}
	}
</style>